export default function Footer() {
  return (
    <footer className="bg-[#001529] pt-0 pb-8 px-0">
      <div className="max-w-full">

        {/* === PROMINENT CTA BANNER === */}
        <div className="bg-gradient-to-r from-[#001529] via-[#002244] to-[#001529] border-t border-emerald-500/20 px-5 sm:px-10 lg:px-16 py-10 sm:py-14">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 bg-emerald-500/10 border border-emerald-500/20 rounded-full px-4 py-1.5 mb-5">
              <div className="w-1.5 h-1.5 bg-emerald-400 rounded-full animate-pulse"></div>
              <span className="text-emerald-400 text-xs font-bold tracking-widest uppercase" style={{ fontFamily: 'Inter, sans-serif' }}>
                Verification Portal Active
              </span>
            </div>
            <h2
              className="text-2xl sm:text-3xl md:text-4xl font-black text-white leading-tight mb-3 tracking-tight"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Ready to Verify Your Asset?
            </h2>
            <p className="text-slate-400 text-sm sm:text-base mb-8 max-w-xl mx-auto" style={{ fontFamily: 'Inter, sans-serif' }}>
              Get your Swiss-certified BPI Compliance Certificate in under 5 minutes.
              USDC &amp; USDT (ERC-20) supported. Fee: $0.10 – $0.80 per audit.
            </p>
            <a
              href="https://mycryptoaml.com/verification"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-3 bg-emerald-500 hover:bg-emerald-400 text-white px-8 sm:px-12 py-4 sm:py-5 rounded-xl font-black text-base sm:text-lg transition-all duration-200 whitespace-nowrap cursor-pointer w-full sm:w-auto"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              <i className="ri-shield-check-line text-xl"></i>
              Proceed to Asset Verification
            </a>
          </div>
        </div>

        {/* === EXISTING FOOTER CONTENT === */}
        <div className="px-5 sm:px-10 lg:px-16 pt-12 sm:pt-16">
          <div className="max-w-7xl mx-auto">
            {/* Top grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 mb-10 sm:mb-14">
              {/* Brand */}
              <div className="lg:col-span-2">
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-9 h-9 bg-emerald-500 rounded-md flex items-center justify-center flex-shrink-0">
                    <i className="ri-shield-check-fill text-white text-base"></i>
                  </div>
                  <div>
                    <div
                      className="text-white font-black text-base leading-none"
                      style={{ fontFamily: 'Montserrat, sans-serif' }}
                    >
                      BPI Holding SA
                    </div>
                    <div className="text-emerald-400 text-[10px] font-bold tracking-[0.2em] uppercase mt-0.5">
                      Crypto AML/KYC
                    </div>
                  </div>
                </div>
                <p
                  className="text-slate-400 text-sm leading-relaxed mb-5 max-w-sm"
                  style={{ fontFamily: 'Inter, sans-serif' }}
                >
                  Institutional-grade digital asset verification and AML compliance services.
                  Protecting institutional liquidity through deep-tier USDC/USDT ERC-20 smart contract
                  audits and Swiss-certified BPI Compliance Certificates.
                </p>
                <div className="space-y-2">
                  <div className="flex items-start gap-2">
                    <i className="ri-map-pin-2-line text-emerald-500 text-sm mt-0.5 flex-shrink-0"></i>
                    <span className="text-slate-500 text-xs sm:text-sm" style={{ fontFamily: 'Inter, sans-serif' }}>
                      c/o Berney et Associés SA, Rue du Nant 8, 1207 Genève, Switzerland
                    </span>
                  </div>
                  <div className="flex items-center gap-2">
                    <i className="ri-file-list-3-line text-emerald-500 text-sm flex-shrink-0"></i>
                    <span className="text-slate-500 text-xs sm:text-sm" style={{ fontFamily: 'Inter, sans-serif' }}>
                      Register: CH-660.0.201.959-2
                    </span>
                  </div>
                  <div className="flex items-center gap-2">
                    <i className="ri-user-star-line text-emerald-500 text-sm flex-shrink-0"></i>
                    <span className="text-slate-500 text-xs sm:text-sm" style={{ fontFamily: 'Inter, sans-serif' }}>
                      Management: Ekaterina Butler
                    </span>
                  </div>
                </div>
              </div>

              {/* Verification Services */}
              <div>
                <h4
                  className="text-white font-bold text-sm mb-5 tracking-wide"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  Verification Services
                </h4>
                <ul className="space-y-3">
                  {[
                    'Proceed to Asset Verification',
                    'Smart Contract Audit',
                    'BPI Certificate',
                    'Blacklist Screening',
                    'Wallet Provenance',
                  ].map((item, i) => (
                    <li key={i}>
                      <a
                        href="https://mycryptoaml.com/verification"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-slate-400 hover:text-emerald-400 transition-colors text-xs sm:text-sm cursor-pointer"
                        style={{ fontFamily: 'Inter, sans-serif' }}
                      >
                        {item}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Legal & Compliance */}
              <div>
                <h4
                  className="text-white font-bold text-sm mb-5 tracking-wide"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  Legal &amp; Compliance
                </h4>
                <ul className="space-y-3">
                  {[
                    { label: 'Terms of Service', href: '/terms', alert: false },
                    { label: 'Privacy Policy', href: '/privacy', alert: false },
                    { label: 'AML / KYC Policy', href: '/aml-policy', alert: false },
                    { label: 'Report Suspicious Activity', href: '/report', alert: true },
                    { label: 'FINMA Compliance', href: '/compliance', alert: false },
                  ].map((item, i) => (
                    <li key={i}>
                      <a
                        href={item.href}
                        className={`transition-colors text-xs sm:text-sm cursor-pointer ${
                          item.alert
                            ? 'text-red-400 hover:text-red-300 font-medium'
                            : 'text-slate-400 hover:text-emerald-400'
                        }`}
                        style={{ fontFamily: 'Inter, sans-serif' }}
                      >
                        {item.alert && <i className="ri-flag-line mr-1 text-xs"></i>}
                        {item.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Regulatory badges */}
            <div className="border-t border-white/10 pt-6 sm:pt-8 mb-6 sm:mb-8">
              <div className="flex flex-wrap items-center justify-center gap-3">
                {[
                  { label: 'FATF Compliant', icon: 'ri-global-line' },
                  { label: 'Swiss FINMA', icon: 'ri-shield-star-line' },
                  { label: 'OFAC Checked', icon: 'ri-government-line' },
                  { label: 'EU MiCA Aligned', icon: 'ri-europe-line' },
                  { label: 'ISO 27001', icon: 'ri-lock-password-line' },
                ].map((badge, i) => (
                  <div
                    key={i}
                    className="flex items-center gap-1.5 border border-white/10 bg-white/5 rounded-full px-3 py-1.5"
                  >
                    <i className={`${badge.icon} text-emerald-500 text-xs`}></i>
                    <span className="text-slate-400 text-xs font-medium" style={{ fontFamily: 'Inter, sans-serif' }}>
                      {badge.label}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            {/* Bottom bar */}
            <div className="border-t border-white/10 pt-5 flex flex-col sm:flex-row items-center justify-between gap-3">
              <p
                className="text-slate-500 text-xs text-center sm:text-left"
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                &copy; 2024 BPI Holding SA. All rights reserved. Registered in Geneva, Switzerland. Company limited by shares (AG).
              </p>
              <div className="flex items-center gap-2">
                <div className="w-1.5 h-1.5 bg-emerald-500 rounded-full animate-pulse"></div>
                <span className="text-slate-500 text-xs" style={{ fontFamily: 'Inter, sans-serif' }}>
                  Verification Portal Active
                </span>
              </div>
            </div>

            {/* Disclaimer */}
            <p
              className="text-slate-600 text-xs mt-4 text-center leading-relaxed max-w-4xl mx-auto"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              BPI Holding SA provides digital asset compliance and verification services. This website does not
              constitute financial, legal, or investment advice. Verification certificates are issued for informational
              and compliance purposes only. BPI Holding SA is not liable for decisions made based on verification results.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
